import { municipalidadTypes } from '../../types/municipalidadTypes'

export const getMunicipalidades = ( payload ) => ({
    type: municipalidadTypes.MUNICIPALIDAD_GET_START,
    payload
})

export const resetMunicipalidades = ( payload = [] ) => ({
    type: municipalidadTypes.MUNICIPALIDAD_RESET,
    payload
})
